<template>
  <!--
    外壳组件：模拟 wnzhzj.com 站点布局。
    所有 class 加 nh- 前缀避免污染原项目 css，
    关键样式从 wnzhzj 的 main.css / public.css 内联进来。
  -->
  <div class="nh-layout">
    <!-- 顶栏 -->
    <div class="nh-header">
      <div class="nh-boxcenter nh-container">
        <a :href="logoHref" target="_blank">
          <img :src="logoUrl" class="nh-logo" />
        </a>
        <div class="nh-header_r">
          <div class="nh-header_r2">
            <div class="nh-search">
              <input type="text" class="nh-ser_ipt" placeholder="请输入关键词" />
              <input type="button" class="nh-ser_sub" value="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 横向导航 -->
    <div class="nh-nav">
      <ul class="nh-boxcenter nh-container nh-nav-list">
        <li
          v-for="(item, idx) in navList"
          :key="idx"
          :class="{
            'nh-home': item.home,
            'nh-active': isActive(item),
          }"
        >
          <a
            :href="item.href || 'javascript:void(0);'"
            :target="item.external ? '_blank' : '_self'"
            :title="item.name"
            @click="handleNavClick($event, item)"
          >
            {{ item.name }}
          </a>
          <span class="nh-nav_up"></span>
          <div
            v-if="item.children && item.children.length"
            class="nh-subnav"
          >
            <a
              v-for="(c, ci) in item.children"
              :key="ci"
              :href="c.href || 'javascript:void(0);'"
              :target="c.external ? '_blank' : '_self'"
            >
              {{ c.name }}
            </a>
          </div>
        </li>
      </ul>
    </div>

    <!-- 主内容区：面包屑 + slot -->
    <div class="nh-main nh-boxcenter nh-container">
      <div class="nh-station">
        <font>当前位置： </font>
        <a>首页</a>
        <template v-for="(b, i) in breadcrumbs" :key="i">
          ><a>{{ b.name }}</a>
        </template>
      </div>
      <slot />
    </div>

    <!-- 底栏 -->
    <div class="nh-foot3">
      <div class="nh-boxcenter nh-container">
        <span>主办：万年县住房和城乡建设局</span>
        <span>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">赣ICP备2023005973号-2</a>
        </span>
        <span>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=36011102000958" target="_blank">赣公网安备36011102000958</a>
        </span>
        <span>技术支持：南昌创沃科技有限公司</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';

const props = defineProps({
  breadcrumbs: {
    type: Array,
    default: () => [
      { name: '便民查询', href: 'https://www.wnzhzj.com/bianminchaxun/index.html' },
      { name: '新房购置' },
    ],
  },
});

const route = useRoute();

const logoUrl = `${process.env.BASE_URL}static/images/g20_200401logo.png`;
const logoHref = 'https://www.wnzhzj.com/';

const navList = [
  { name: '首页', home: true, href: 'https://www.wnzhzj.com/index.html' },
  {
    name: '通知公告',
    href: 'https://www.wnzhzj.com/tongzhigonggao/index.html',
    children: [
      { name: '信息公示', href: 'https://www.wnzhzj.com/tongzhigonggao/xinxigongshi/index.html' },
    ],
  },
  {
    name: '公告公示',
    href: 'https://www.wnzhzj.com/gonggaogongshi/index.html',
    children: [
      { name: '企业公示', href: 'https://www.wnzhzj.com/gonggaogongshi/qiyegongshi/index.html' },
      { name: '预售公示', href: 'https://www.wnzhzj.com/gonggaogongshi/yushouzhenggongshi/index.html' },
      { name: '现售公示', href: 'https://www.wnzhzj.com/gonggaogongshi/beiangongshi/index.html' },
      { name: '商品房楼盘公示', href: 'https://www.wnzhzj.com/gonggaogongshi/shangpinfangxiangmugongshi/index.html' },
      { name: '维修资金申请使用公示', href: 'https://www.wnzhzj.com/gonggaogongshi/weijiuzijinshenqingshiyong/index.html' },
      { name: '房地产中介服务机构公示', href: 'https://www.wnzhzj.com/gonggaogongshi/fangdichangzhongjiegongshi/index.html' },
    ],
  },
  {
    name: '政务服务',
    href: 'https://www.wnzhzj.com/zhengwufuwu/index.html',
    children: [
      { name: '江西政务服务网', href: 'http://srwn.jxzwfww.gov.cn/jxzw/czbm/index.do?webId=75&orgCode=3611290015&flag=gj', external: true },
      { name: '服务事项', href: 'https://www.wnzhzj.com/zhengwufuwu/fuwushixiang/index.html' },
    ],
  },
  {
    name: '办事指南',
    href: 'https://www.wnzhzj.com/banshizhinan/index.html',
    children: [
      { name: '机构入驻', href: 'https://www.wnzhzj.com/banshizhinan/jigouruzhu/index.html' },
      { name: '商品房业务', href: 'https://www.wnzhzj.com/banshizhinan/shangpinfangyewu/index.html' },
      { name: '存量房业务', href: 'https://www.wnzhzj.com/banshizhinan/cunliangyewu/index.html' },
      { name: '资金监管', href: 'https://www.wnzhzj.com/banshizhinan/zijinjianguan/index.html' },
      { name: '专项维修资金', href: 'https://www.wnzhzj.com/banshizhinan/weixiuzijin/index.html' },
    ],
  },
  {
    name: '便民查询',
    href: 'https://www.wnzhzj.com/bianminchaxun/index.html',
    children: [
      { name: '网签备案查询', href: 'https://www.wnzhzj.com/bianminchaxun/wangqianbeianchaxun/index.html' },
      { name: '开发企业查询', href: 'https://www.wnzhzj.com/bianminchaxun/kaifaqiyechaxun/index.html' },
      { name: '预售证查询', href: 'https://www.wnzhzj.com/bianminchaxun/yushouzhengchaxun/index.html' },
      { name: '商品房楼盘查询', href: 'https://www.wnzhzj.com/bianminchaxun/xiangmuxinxichaxun/index.html' },
    ],
  },
  {
    name: '政策法规',
    href: 'https://www.wnzhzj.com/zhengcefagui/index.html',
    children: [
      { name: '政策法规', href: 'https://www.wnzhzj.com/zhengcefagui/zcfg/index.html' },
    ],
  },
];

const isActive = (item) => {
  if (item.name !== '便民查询') return false;
  return route.path.startsWith('/new_house');
};

const handleNavClick = (e, item) => {
  if (item.children && item.children.length) return;
  if (item.href && item.href.startsWith('http')) {
    window.open(item.href, '_blank');
    e.preventDefault();
  }
};
</script>

<style lang="scss">
/* 关键样式（从 wnzhzj 站点 main.css / public.css 复制，所有类名前加 nh- 前缀） */
.nh-layout {
  min-height: 100vh;
  background: #fff url('~@/../public/static/images/g20_200401bg.jpg') no-repeat center bottom fixed;
  background-size: 100%;
}

.nh-boxcenter { margin: 0 auto; }
.nh-container { width: 1200px; }

.nh-header {
  height: 196px;
  position: relative;
  overflow: hidden;
}
.nh-logo { margin-top: 66px; width: 443px; }
.nh-header_r { float: right; margin-top: 58px; }
.nh-header_r2 { display: flex; align-items: center; }
.nh-search {
  width: 400px;
  height: 40px;
  line-height: 40px;
  background: #fff;
  float: right;
  box-shadow: 0 0 10px #efefef;
  margin-left: 30px;
  display: flex;
  align-items: center;
  padding: 0 12px;
}
.nh-ser_ipt {
  flex: 1;
  border: none;
  outline: none;
  height: 100%;
  background: transparent;
  font-size: 14px;
}
.nh-ser_sub {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
}

/* 横向导航：红色背景 + 白字 */
.nh-nav {
  position: relative;
  background: #bd1a2d;
  border-top: 2px solid #bd1a2d;
  border-bottom: 2px solid #bd1a2d;
}
.nh-nav-list {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  height: 56px;
  align-items: center;
}
.nh-nav-list > li {
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 18px;
}
.nh-nav-list > li > a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  line-height: 56px;
  position: relative;
}
.nh-nav-list > li.nh-home > a {
  /* home 通常带图标，此处不强调 */
}
.nh-nav-list > li:hover > a,
.nh-nav-list > li.nh-active > a {
  color: #fff8e1;
}
.nh-nav_up {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0;
  height: 0;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  display: none;
}
.nh-nav-list > li:hover > .nh-nav_up,
.nh-nav-list > li.nh-active > .nh-nav_up {
  display: block;
  border-bottom-color: #bd1a2d;
}

/* 子菜单 */
.nh-subnav {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  background: #fff6e2;
  border-bottom: 1px solid #f7ce8c;
  line-height: 40px;
  z-index: 100;
  padding: 0 16px;
  white-space: nowrap;
}
.nh-nav-list > li:hover > .nh-subnav {
  display: block;
}
.nh-subnav a {
  display: inline-block;
  padding: 0 16px;
  color: #000;
  text-decoration: none;
}
.nh-subnav a:hover {
  color: #bd1a2d;
}

/* 主内容区 */
.nh-main {
  min-height: calc(100vh - 320px);
  text-align: left;
  padding-top: 16px;
  padding-bottom: 24px;
  box-sizing: border-box;
}
.nh-station {
  padding-left: 30px;
  font-size: 16px;
  margin-bottom: 24px;
  color: #404040;
}
.nh-station a { color: #404040; text-decoration: none; margin: 0 4px; }
.nh-station a:hover { color: #bd1a2d; }

/* 底栏 */
.nh-foot3 {
  background: #bd1a2d;
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  text-align: center;
  color: #fff;
}
.nh-foot3 span { margin: 0 20px; }
.nh-foot3 a { color: #fff; text-decoration: none; }
</style>
